module.exports = __webpack_public_path__ + "assets/media/no-calendar-error-icon.1fb73dfa.svg";